var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h100"},[_c('div',{staticClass:"w-table-layout"},[_c('div',{ref:"menusContent",staticClass:"w-table-content"},[_c('el-tree',{attrs:{"data":_vm.menusTreeData.treeData,"props":_vm.defaultProps,"expand-on-click-node":false,"highlight-current":true,"default-expand-all":""},on:{"node-click":_vm.handleNodeClick}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }